/**
 * Every module, in install order.
 *
 * Imported only by the default entry point. Variant entries import the modules
 * they want directly, so nothing here reaches a bundle that did not ask for it —
 * pulling this list into the registry would compile every module into every
 * bundle and undo the whole point of building variants.
 *
 * privacy comes first: it swaps in the real consent gate and privacy api that
 * the kernel awaits once install finishes.
 */

import type { SdkModuleDefinition } from './types';
import { privacyModule } from './privacy/module';
import { poolModule } from './pool/module';
import { ecomModule } from './ecom/module';
import { pixelsModule } from './pixels/module';
import { mbpModule } from './mbp/module';

export const ALL_MODULES: readonly SdkModuleDefinition[] = [
  privacyModule,
  poolModule,
  ecomModule,
  pixelsModule,
  mbpModule,
];
